import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

// Local assets (downloaded from Figma)
const imgPiecrip = "/assets/newGNB/logo-piecrip.png";
const imgGroup = "/assets/newGNB/logo-sunrise.svg";

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 21px;
  position: relative;
  text-decoration: none;
  cursor: pointer;
  
  &:hover {
    opacity: 0.9;
  }
`;

const SunriseIcon = styled.div`
  width: 40px;
  height: 27px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const PiecripImage = styled.img`
  height: 21px;
  width: auto;
  object-fit: contain;
`;

const Logo: React.FC = () => {
  return (
    <LogoContainer to="/">
      <SunriseIcon>
        <img src={imgGroup} alt="Sunrise" />
      </SunriseIcon>
      <PiecripImage src={imgPiecrip} alt="Piecrip" />
    </LogoContainer>
  );
};

export default Logo;
